<template>
    <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900">تعديل اعدادات التطبيق</h1>
                <p class="mt-2 text-sm text-gray-700"></p>
            </div>
        </div>
        <div class="mt-3 col-span-6 sm:col-span-3">
            <label for="last-name" class="block text-lg font-medium text-gray-700">تعديل رسالة حفظة</label>
            <input v-model="mesHafadh" type="text" name="last-name" id="last-name" autocomplete="family-name"
                class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
        </div>

        <div class="mt-3 col-span-6 sm:col-span-3">
            <label for="last-name" class="block text-lg font-medium text-gray-700">تعديل رابط دعم حفظة</label>
            <input v-model="hafadhLink" type="text" name="last-name" id="last-name" autocomplete="family-name"
                class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
        </div>

        <!--
            التحديث الإجباري وإعدادات Agora انتقلت إلى صلاحية الادارة العامة فقط:
              - التحديث الإجباري  -> /tenant-app-update-configs
              - إعدادات Agora     -> /tenant-agora-configs
            كلاهما يُداران لكل فرع من هناك. لا تُعِد إضافتها هنا — الواجهة الخلفية
            ترفض هذه الأكواد (403) لغير الادارة العامة.
        -->

        <div class="mt-8 border-t border-gray-200 pt-6">
            <h2 class="text-lg font-semibold text-gray-900 mb-4">إعدادات خدمات الصفحة الرئيسية (الجوال)</h2>
            <p class="text-sm text-gray-500 mb-4">
                تفعيل/تعطيل ظهور كل بطاقة في الصفحة الرئيسية لتطبيق الجوال لهذا الـ tenant.
            </p>
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">الجلسات البديلة</span>
                    <input type="checkbox" v-model="homeServiceToggles.alternativeSessions"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">التسميع الجماعي</span>
                    <input type="checkbox" v-model="homeServiceToggles.peerReview"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">الدوائر العامة</span>
                    <input type="checkbox" v-model="homeServiceToggles.publicCircles"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">كرت الاشتراك مع المعلم</span>
                    <input type="checkbox" v-model="homeServiceToggles.subscriptionCard"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">كرت الورد اليومي</span>
                    <input type="checkbox" v-model="homeServiceToggles.dailyWird"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
                <div class="rounded-md border border-gray-200 p-3">
                    <label class="block text-sm font-medium text-gray-700 mb-1">الهدف اليومي للورد (أوجه)</label>
                    <input v-model.number="dailyWirdTargetFaces" type="number" min="1" placeholder="مثال: 100"
                        class="focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    <p class="mt-1 text-xs text-gray-500">عدد الأوجه المستهدف يومياً لحساب نسبة التقدم (خاص بالفرع).</p>
                </div>
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">كرت احجز الآن (بدون حجز)</span>
                    <input type="checkbox" v-model="homeServiceToggles.bookNowCard"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">قسم الرسائل</span>
                    <input type="checkbox" v-model="homeServiceToggles.messages"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
                <label class="flex items-center justify-between rounded-md border border-gray-200 p-3">
                    <span class="text-sm font-medium text-gray-700">كرت الدعم الفني</span>
                    <input type="checkbox" v-model="homeServiceToggles.supportCard"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                </label>
            </div>
        </div>

        <div dir="ltr" class="mt-10"> <button class="button" type="submit" @click="editSetting()">
                تعديل الاعدادات
            </button>
        </div>
        <div dir="ltr" class="mt-5">
            <button class="button" type="button" @click="triggerDailyTracker">
                تشغيل المتتبع اليومي
            </button>
        </div>
    </div>



</template>


<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            mesHafadh: '',
            hafadhLink: '',
            homeServiceToggles: {
                alternativeSessions: true,
                peerReview: true,
                publicCircles: true,
                subscriptionCard: true,
                dailyWird: true,
                bookNowCard: true,
                messages: true,
                supportCard: true,
            },
            dailyWirdTargetFaces: 100,
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            // Get tenant_id from JWT token
            let tenantId = null;
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    tenantId = payload.tenantId || payload.tenant_id || null;
                }
            } catch (e) {
                console.warn('Could not extract tenantId from token:', e);
            }

            // Build URL with tenantId as query parameter
            let urlWithParams = url.get_config;
            if (tenantId) {
                urlWithParams += `?tenantId=${encodeURIComponent(tenantId)}`;
            }

            axios.get(process.env.VUE_APP_SERVICE_URL + urlWithParams)
                .then(response => {
                    if (response.status == 200) {
                        response.data.result.data.forEach((item) => {
                            console.log(item);
                            if (item.code == "ADMIN_MESSAGE") {
                                this.mesHafadh = item.value;
                            }
                            else if (item.code == "PAYMENT_LINK") {
                                this.hafadhLink = item.value;
                            } else if (item.code == "HOME_SHOW_ALTERNATIVE_SESSIONS") {
                                this.homeServiceToggles.alternativeSessions = this.parseConfigBool(item.value);
                            } else if (item.code == "HOME_SHOW_PEER_REVIEW") {
                                this.homeServiceToggles.peerReview = this.parseConfigBool(item.value);
                            } else if (item.code == "HOME_SHOW_PUBLIC_CIRCLES") {
                                this.homeServiceToggles.publicCircles = this.parseConfigBool(item.value);
                            } else if (item.code == "HOME_SHOW_SUBSCRIPTION_CARD") {
                                this.homeServiceToggles.subscriptionCard = this.parseConfigBool(item.value);
                            } else if (item.code == "HOME_SHOW_DAILY_WIRD") {
                                this.homeServiceToggles.dailyWird = this.parseConfigBool(item.value);
                            } else if (item.code == "DAILY_WIRD_TARGET_FACES") {
                                const n = parseInt(item.value, 10);
                                this.dailyWirdTargetFaces = isNaN(n) || n < 1 ? 100 : n;
                            } else if (item.code == "HOME_SHOW_BOOK_NOW_CARD") {
                                this.homeServiceToggles.bookNowCard = this.parseConfigBool(item.value);
                            } else if (item.code == "HOME_SHOW_MESSAGES") {
                                this.homeServiceToggles.messages = this.parseConfigBool(item.value);
                            } else if (item.code == "HOME_SHOW_SUPPORT_CARD") {
                                this.homeServiceToggles.supportCard = this.parseConfigBool(item.value);
                            }
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching data', error);
                });

        },
        async editSetting() {
            try {
                // Get tenant_id from JWT token
                let tenantId = null;
                try {
                    const token = localStorage.getItem('token');
                    if (token) {
                        const payload = JSON.parse(atob(token.split('.')[1]));
                        tenantId = payload.tenantId || payload.tenant_id || null;
                    }
                } catch (e) {
                    console.warn('Could not extract tenantId from token:', e);
                }

                // NOTE: FORCE_UPDATE_*, MIN_VERSION_* and AGORA_* are deliberately absent.
                // They are super-admin scope now and the API returns 403 if they appear here.
                const requestData = {
                    "ADMIN_MESSAGE": this.mesHafadh,
                    "PAYMENT_LINK": this.hafadhLink,
                    "HOME_SHOW_ALTERNATIVE_SESSIONS": this.toConfigFlag(this.homeServiceToggles.alternativeSessions),
                    "HOME_SHOW_PEER_REVIEW": this.toConfigFlag(this.homeServiceToggles.peerReview),
                    "HOME_SHOW_PUBLIC_CIRCLES": this.toConfigFlag(this.homeServiceToggles.publicCircles),
                    "HOME_SHOW_SUBSCRIPTION_CARD": this.toConfigFlag(this.homeServiceToggles.subscriptionCard),
                    "HOME_SHOW_DAILY_WIRD": this.toConfigFlag(this.homeServiceToggles.dailyWird),
                    "DAILY_WIRD_TARGET_FACES": String(Math.max(1, parseInt(this.dailyWirdTargetFaces, 10) || 100)),
                    "HOME_SHOW_BOOK_NOW_CARD": this.toConfigFlag(this.homeServiceToggles.bookNowCard),
                    "HOME_SHOW_MESSAGES": this.toConfigFlag(this.homeServiceToggles.messages),
                    "HOME_SHOW_SUPPORT_CARD": this.toConfigFlag(this.homeServiceToggles.supportCard),
                };

                // Add tenantId if available
                if (tenantId) {
                    requestData.tenantId = tenantId;
                }

                const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.change_config,
                    requestData,
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    }
                );
                alert(response.data.result.mesAr);
                return;
            } catch (error) {
                const mesAr = error.response?.data?.result?.mesAr;
                alert(mesAr || 'حدث خطأ ما الرجاء المحاولة مرة اخرى');
            }
        },
        parseConfigBool(value) {
            if (value === null || value === undefined) {
                return true;
            }
            const normalized = String(value).trim().toLowerCase();
            if (normalized === '0' || normalized === 'false' || normalized === 'off') {
                return false;
            }
            return true;
        },
        toConfigFlag(value) {
            return value ? '1' : '0';
        },
        async triggerDailyTracker() {
            try {
                const response = await axios.post(
                    process.env.VUE_APP_SERVICE_URL + url.trigger_daily_tracker,
                    {},
                    {
                        params: { force: true },
                        headers: { 'X-Authorization': localStorage.getItem('token') }
                    }
                );
                alert(response.data.result.mesAr);
            } catch (error) {
                if (error.response && error.response.data && error.response.data.result && error.response.data.result.mesAr) {
                    alert(error.response.data.result.mesAr);
                } else {
                    alert('خطأ في تشغيل المتتبع اليومي');
                }
            }
        }
    }
})

</script>

<style scoped>
.button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-40 h-10;
}
</style>
